exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-72301957] .el-transfer-panel__body {\n  height: 300px;\n}\n[data-v-72301957] .el-transfer-panel__list.is-filterable {\n  height: 245px;\n  padding-top: 0;\n}\n[data-v-72301957] .el-transfer-panel .el-transfer-panel__header {\n  background: #78a5e7;\n}\n[data-v-72301957] .el-transfer-panel\n.el-transfer-panel__header\n.el-checkbox\n.el-checkbox__label\nspan {\n  color: white;\n}\n[data-v-72301957] .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {\n  color: white;\n}\n[data-v-72301957] .el-transfer-panel {\n  width: 500px;\n}\n", ""]);

// exports
